<template>
    <div style="padding: 20px;"><b>Battery level:</b> {{ batteryLevel }}
    <button @click="CallMauiAppInVue('getbattery')">Get battery</button></div>
</template>

<script>
export default {
    name: "batteryLevel",
    data() {
        return{
            batteryLevel: 0
         
        };
       
    },
    methods: {
        setBatteryLevel(value) {
            this.batteryLevel = value;
            console.log("Battery:" + value)
        } ,

        CallMauiAppInVue(fu, arg) {

 //          if(true) {
                window.location.href =   "myapp://runcsharp." + fu + "?args=" + arg;
   //         }
   //         else {
   //         console.log("Sorry, can't do that if not running in Morten's app.")
   //         }
        }

        
   
    }
    
}
</script>
